const $OrdBox = (_1, _2, _3) => ({tag: "OrdBox", _1, _2, _3});
const OrdBox = value0 => value1 => value2 => $OrdBox(value0, value1, value2);
const unOrdBox = v => v._3;
const mkOrdBox = dictOrd => OrdBox(dictOrd.Eq0().eq)(dictOrd.compare);
const eqOrdBox = {eq: v => v1 => v._1(v._3)(v1._3)};
const ordOrdBox = {compare: v => v1 => v._2(v._3)(v1._3), Eq0: () => eqOrdBox};
export {$OrdBox, OrdBox, eqOrdBox, mkOrdBox, ordOrdBox, unOrdBox};
